module.exports = __webpack_public_path__ + "img/ski-pant.d0efdc3f.png";